import { GetJobPositionDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useJobPosition = (id: string) => {
  const { loading, data } = useQuery(GetJobPositionDocument, { variables: { id } })

  return {
    loading,
    jobPosition: data?.positions.position,
  }
}
